import { yupResolver } from "@hookform/resolvers/yup";
import { getToday } from "api/constants";
import { GetDownloadCategories, PostDownloads, PostHomeSliders, UploadFile } from "api/endpoints";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import FilePreviewer from "components/ckeditor/MEIFilePreview";
import MEILoader from "components/ckeditor/MEILoader";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { Card, FloatingLabel, } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FiUpload } from "react-icons/fi";
import { toast } from "react-toastify";
import * as yup from "yup";
// import ProductBasicInfo from "./add-product-tab/ProductBasicInfo";

const schema = yup
  .object({
    fTitle: yup.string(),
    fDescription: yup.string(),
    // fFile: yup.string().required("File is required."),
    fFile: yup.string(),
    mType: yup.string().required("Please select valid media type"),
    fStatus: yup.string().required("Status is required."),
    fSon: yup.string().required("Show on is required."),
    fOrder: yup.number().required("Sequence is required.").min(0, 'Please enter valid number'),
  })
  .required();

const initialForm = {
  fTitle: '',
  fDescription: '',
  fFile: '',
  mType: 'image',
  fStatus: 'true',
  fSon: 'piciip',
  fOrder: '0',

};

const ProductBasicInfo = ({ setLoading }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useFormContext();


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      const allowedTypes = [
        'image/jpeg', // .jpg, .jpeg
        'image/png',  // .png
        'video/mp4' // .mp4
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid File Format', {
          theme: "colored",
        });
        e.target.value = '';
        return
      }
      else {
        setLoading(true)
        const formData = new FormData();
        formData.append('file', file);

        UploadFile(formData).then(res => {
          // toast.success('File Uploaded Successfully!', {
          //   theme: "colored",
          // });
          setValue('fFile', res?.data)
          e.target.value = '';
          setLoading(false)

        }).catch(err => {
          setLoading(false)
          toast.error('File Uploading Failed', {
            theme: "colored",
          });
        });
      }
    }
  };

  return (
    <Row className="gx-2 gy-3">

      <Col md="12">
        <Form.Group>
          {/* <Form.Label>First name:</Form.Label> */}
          <FloatingLabel
            controlId="floatingInput"
            label="Title"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fTitle}
              {...register("fTitle")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fTitle?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



      <Col md="12">

        <Form.Label>Description</Form.Label>
        <MEICKEditor
          value={getValues('fDescription')}
          onchangeValue={(vl) => {
            setValue('fDescription', vl)
          }} />

      </Col>

      {/* <Col md="12">
        <Form.Group>
          <FloatingLabel
            controlId="floatingInput"
            label="Description"
            className=""
          >
            <Form.Control
              as="textarea"
              rows={4}
              placeholder=""
              isInvalid={!!errors.fDescription}

              style={{ height: '120px' }}
              {...register("fDescription")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fDescription?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col> */}







      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Media Type" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.mType}
              {...register("mType")}
              onChange={e => {
                setValue(e.target.name, e.target.value)
                setValue('fFile', '')
              }}
            >
              <option value="image">Image</option>
              <option value="video">Video</option>
              <option value="youtube">Embed Youtube Video</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.mType?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



      <Col md="8" style={{ position: 'relative' }}>
        {watch('mType') === 'youtube' &&
          <Form.Group>
            <FloatingLabel
              controlId="floatingInput"
              label={watch('mType') !== 'youtube' ? "Slider Media" : "Slider Media URL"}
              className=""
            >
              <Form.Control
                type="text"
                placeholder=""
                isInvalid={!!errors.fFile}
                // style={{height: '80px'}}
                {...register("fFile")}
                onKeyDown={e => {
                  if (watch('mType') !== 'youtube')
                    e.preventDefault()
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.fFile?.message}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        }
        {watch('mType') !== 'youtube' &&
          <>
            <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
              Slider Media (1920 x 1280)
            </Form.Label>
            <FilePreviewer accept={watch('mType') === 'image' ?
                " .jpg, .jpeg, .png, "
                :
                ".mp4"
              } furl={watch('fFile')} />


            <Form.Label htmlFor={`file-upload-sd`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
              <FiUpload className="me-1" size={40} />
            </Form.Label>
            <Form.Control
              id={`file-upload-sd`}
              type="file"
              style={{ width: '120px' }}
              onChange={(e) => handleFileChange(e)}
              className="d-none"
              accept={watch('mType') === 'image' ?
                " .jpg, .jpeg, .png, "
                :
                ".mp4"
              }
            />
          </>
        }

      </Col>

      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Status" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.fStatus}
              {...register("fStatus")}
            >
              <option value="true">Published</option>
              <option value="false">Un-Published</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fStatus?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>
      
      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Show On" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.fSon}
              {...register("fSon")}
            >
              <option value="piciip">PICIIP Site</option>
              <option value="landing">Landing Page</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fSon?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
            <Form.Control
              type="number"
              placeholder=""
              isInvalid={!!errors.fOrder}
              {...register("fOrder")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fOrder?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



    </Row>
  );
};


const AddSlider = ({ handleDiscard, editData }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset } = methods;


  useEffect(() => {
    if (editData?.id) {
      reset({
        fTitle: editData.title,
        fDescription: editData.description,
        fFile: editData.mediaUrl,
        mType: editData.contentType,
        fStatus: editData.status.toString(),
        fSon: editData.duration,
        fOrder: editData.sortOrder,
      })
    }
    else {
      reset(initialForm);
    }

  }, [editData])

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    console.log(data);
    // // ------- Get all object keys form data and set empty values to reset ------------
    // const keys = Object.keys(data);
    // for (const key of keys) {
    //   submittedValues[key] = "";
    // }

    setLoading(true)
    const finalData = {
      id: editData?.id ? editData?.id : 0,
      title: data.fTitle,
      description: data.fDescription,
      mediaUrl: data.fFile,

      contentType: data.mType,
      status: data.fStatus === "true",
      sortOrder: data.fOrder,
      mediaType: 'HOME_SLIDER',

      mediaName: "",
      size: 0,
      duration: data.fSon,
    }

    PostHomeSliders(finalData).then(res => {

      toast.success('Data Saved Successfully', {
        theme: "colored",
      });
      setLoading(false)
      reset(initialForm)
      handleDiscard(true);

    }).catch(err => {

      toast.error('Data Saving Failed', {
        theme: "colored",
      });
      setLoading(false)
      console.log(err, 'PostDownloadsError')

    });


  };

  const handleDiscardPre = () => {
    reset(initialForm)
    handleDiscard();
  }

  return (
    <>

      <MEILoader showLoader={loading} />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">

            <Col lg={12}>
              <ProductBasicInfo setLoading={setLoading} />
            </Col>

            <Col xs={12}>
              <Row className="flex-between-center mt-3">
                <Col md>
                  {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={handleDiscardPre}
                  >
                    Discard
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {editData?.id ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            </Col>

          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddSlider;
